import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled from 'styled-components';

const CloseButton = styled.span`
    display: block;
    position: absolute;
    right: 10px;
    top: 18px;
    cursor: pointer;
`;

const Notification = ({ message, isDismissable, actions}) => {
  return (
      <div className={ classnames(['notification', {['is-active']: message !== ''}])}>
        { message }
        { isDismissable &&
        <CloseButton onClick={ actions.hideNotification }>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill='#FFFFFF' d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
        </CloseButton>
        }
      </div>
  )
};

Notification.propTypes = {
  actions: PropTypes.object,
  isDismissable: PropTypes.bool,
  message: PropTypes.string
};

export default Notification;



// WEBPACK FOOTER //
// ./src/components/Notification/Notification.js